// Module
var code = "<template>\n  ${name | emptyDash}\n</template>\n";
// Exports
export default code;